/* eslint-disable react/jsx-indent */
import React, { Component } from 'react'
import { Card, CardBody, Media } from 'reactstrap'

class SimpleCard extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { title, text, footer, additionalData, standard } = this.props

    if (standard) {
      return (
        <Card>
          <CardBody>
            <Media>
              <Media body className="overflow-hidden">
                <p className="text-truncate font-size-14 mb-2">{title}</p>
                <h4 className="mb-0">{text}</h4>
              </Media>
            </Media>
          </CardBody>
          {footer && (
            <CardBody className="border-top py-3">
              <div className="text-truncate">
                {footer}
              </div>
            </CardBody>
          )}
        </Card>
      )
    } else {
      return (
        <Card>
          <CardBody>
            <Media>
              <Media body className="overflow-hidden">
                {title}
                {text}
              </Media>
            </Media>
          </CardBody>
          {footer && (
            <CardBody className="border-top py-3">
              {footer}
            </CardBody>
          )}
        </Card>
      )
    }
  }
}
export default SimpleCard
